// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"9b7690dd","732":"59503a9a","977":"9dc10c7d"}[chunkId] + ".chunk.js";
};